export class ItemsCheckout {
    id:string;
    title : string;
    price : number;
    createdBy : string;
    done : boolean;
    islogged : boolean = false;
    
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/itemsCheckout.ts